import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'web-paid-features-modal',
    templateUrl: './paid-features-modal.component.html',
    styleUrls: ['./paid-features-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslateModule],
})
export class PaidFeaturesModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
